import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import TextBlock from "components/Shared/TextBlock";
import responseHandler from "responseHandler";

class PcrCommentaryDialog extends Component {
  constructor(props) {
    super(props);

    this.getPcrDialogActions = this.getPcrDialogActions.bind(this);
    this.getPcrMenuOptions = this.getPcrMenuOptions.bind(this);
    this.onReasonChange = this.onReasonChange.bind(this);
    this.onReasonCommentChange = this.onReasonCommentChange.bind(this);
    this.savePcrCommentById = this.savePcrCommentById.bind(this);
    this.checkCommentRequired = this.checkCommentRequired.bind(this);
    this.validatePcr = this.validatePcr.bind(this);
    this.mounted = { current: true };

    this.state = {
      currentPcr: props.currentPcr,      
    };
  }

  savePcrCommentById() {
    let validateResp = this.validatePcr();
    if(validateResp){
      this.props.makeToast(validateResp, "warning");
    } else {
      let pcrUpdate = {...this.state.currentPcr};
      pcrUpdate.new = null;
      if(!pcrUpdate.commentary) pcrUpdate.commentary = "";
      this.props.updatePcrCommentary(pcrUpdate);
    }
  }

  validatePcr(){
    const {
      currentPcr
    } = this.state;
    if(currentPcr) {
      if(!currentPcr.reason) {
        return "Reason is Required";
      }
      if(currentPcr.reason) {
        if(currentPcr.reason === "Other w/commentary required" && !currentPcr.commentary){
          return "Commentary is Required when Reason is Other";
        } 
      }
      if(currentPcr.commentary){
        if (currentPcr.commentary.length > 2000) {
          return "Commentary is limited to 2000 characters";
        }        
      }
      else return null;
    } else return "No PCR to Save";
  }

  getPcrDialogActions() {
    const {
      currentPcr
    } = this.state;    
    let actions = [];
    actions.push(<Button color="secondary" disabled={currentPcr.new} onClick={() => this.props.revertPcr(this.state.currentPcr)}>Revert</Button>);    
    actions.push(<Button onClick={this.savePcrCommentById}>Save</Button>);        
    return actions;  
  }

  onReasonChange(e){
    let pcr = {...this.state.currentPcr};
    pcr.reason = e.target.value;
    this.setState({currentPcr: pcr});     
  }

  onReasonCommentChange(e) {
    let pcr = {...this.state.currentPcr};
    pcr.commentary = e.target.value;
    this.setState({currentPcr: pcr});     
  }

  checkCommentRequired(){
    return this.state.currentPcr && 
      this.state.currentPcr.reason === "Other w/commentary required";
  }

  getPcrMenuOptions() {
    return [
      {
        label: "Appraiser confirmed difference to PCR with public records/MLS", 
        value: "Appraiser confirmed difference to PCR with public records/MLS"
      },
      {
        label: "Appraiser knowledge of market confirmed variance to PCR", 
        value: "Appraiser knowledge of market confirmed variance to PCR"
      },
      {
        label: "Appraiser discussed with FR the information from inspection and determined a variance", 
        value: "Appraiser discussed with FR the information from inspection and determined a variance"
      },
      {
        label: "Appraiser confirmed difference to PCR in photos", 
        value: "Appraiser confirmed difference to PCR in photos"
      },
      {
        label: "Appraiser discussed with the borrower information from inspection and determined a variance", 
        value: "Appraiser discussed with the borrower information from inspection and determined a variance"
      },
      {
        label: "Room count variance due to PCR inclusion of non-living areas for inspection purposes", 
        value: "Room count variance due to PCR inclusion of non-living areas for inspection purposes"
      },
      {
        label: "Appraiser determined a variance, however item does not impact value", 
        value: "Appraiser determined a variance, however item does not impact value"
      },
      {
        label: "Other w/commentary required", 
        value: "Other w/commentary required"
      },                                          
    ];
  }

  render() {
    const {
      currentPcr
    } = this.state;
    return (
        <Dialog
          id="pcr-commentary-dialog"
          className="pcr-dialog-container"
          open={true}
          sx={{ '& .MuiDialog-paper': { width: '25%' } }}
        >
          <DialogTitle>PCR Reconciliation</DialogTitle>
          <DialogContent>
            <div className="md-cell md-cell--12">
              <TextBlock field={`Changing this field conflicts with the value supplied by the PCR. Please provide a reason for the change. To remove
                PCR Commentary, revert field to the original value.`} />   
              <TextField
                  id="pcr-justification-selection"
                  label="Reason"
                  className="md-cell md-cell--12"
                  select
                  variant="standard"
                  required={true}
                  helperText={!currentPcr.reason ? "Reason is required." : ""}
                  error={!currentPcr.reason}
                  onChange={this.onReasonChange}
                  value={currentPcr.reason || ""}
                  fullWidth
                >
                  {this.getPcrMenuOptions().map(option => (
                    <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                  ))}
                </TextField>
              <TextField
                id="admin-work-item-note"
                label="Comment"
                placeholder=""
                variant="standard"
                required={this.checkCommentRequired()}
                className="md-cell md-cell--12"
                onChange={this.onReasonCommentChange}
                inputProps={{ maxLength: 2000 }}
                value={currentPcr.commentary || ""}
                multiline
                rows={2}
                fullWidth
              />
              <div />
              <TextBlock field={`Original Value: ${currentPcr.originalValue}`} styleClass="fieldText-bold" />              
            </div>
          </DialogContent>
          <DialogActions>
            {this.getPcrDialogActions()}
          </DialogActions>
        </Dialog>        
    );
  }
}

PcrCommentaryDialog.propTypes = {
  controlNumber: PropTypes.number.isRequired,
  pcrDialogVisible: PropTypes.bool.isRequired,
  currentPcr: PropTypes.object,
  updatePcrCommentary: PropTypes.func.isRequired,
  revertPcr: PropTypes.func.isRequired,
  makeToast: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  makeToast(text, type) {
    responseHandler.customToast(text, type, dispatch);
  },
});

export default connect(null, mapDispatchToProps)(PcrCommentaryDialog);
